import { Component } from '@angular/core';

@Component({ standalone: false,
    selector: 'irb-component-securities-delete-all',
    template: `
        <div >
          @if (hasRows()) {
            <div class="btn-action-close-delete" calltoaction [calltoactionTemplate]="irbComponentSecDeleteAll"></div>
          }
          <ng-template #irbComponentSecDeleteAll>
            <div class="block">{{params.message}}</div>
            @if (params.note) {
              <div class="block">{{params.note}}</div>
            }
            <div class="buttonSet center">
              <div style="margin-bottom: 4px;">
                <button pButton label="Extract" (click)="extractAll()"></button>
              </div>
              <div style="margin-bottom: 4px;">
                <button pButton label="Delete" (click)="deleteAll()" ></button>
              </div>
              <div>
                <button pButton label="Cancel" (click)="cancel()" class="ui-button-secondary"></button>
              </div>
            </div>
          </ng-template>
        </div>`
})
export class ComponentSecuritiesDeleteAllComponent {
    params: any;

    agInit(params: any): void {
        this.params = params;
    }

    cancel() {
        if(typeof this.params.cancel !== "undefined") {
            this.params.cancel();
        }
    }

    extractAll() {
        if(typeof this.params.extractAll !== "undefined") {
            this.params.extractAll();
        }
    }

    deleteAll() {
        if(typeof this.params.deleteAll !== "undefined") {
            this.params.deleteAll();
        }
    }

    hasRows() {
        return this.params.context.componentParent.getRowCount() > 0;
    }
}
